<template>
  <div class="dialog-mask payment-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <!-- <div class="dialog-header" v-if="title">{{title}}</div> -->
      <div class="dialog-body">
        <i class="fa fa-fw" :class="iconClass"></i>
        <p v-if="success === true">{{ 'PaymentIsOk' | lang }}</p>
        <p v-else-if="success === false">{{ 'PaymentIsKo' | lang }}</p>
        <p v-else>{{ 'PaymentIsUnknown' | lang }}</p>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose()">{{ 'Close' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
  name: 'CartPaymentEndDialog',
  mixins: [ dialogMixin ],
  props: ['success'],
  computed: {
    iconClass () {
      if (this.success === true) return 'fa-check-circle-o'
      if (this.success === false) return 'fa-times-circle-o'
      return 'fa-question-circle-o'
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

.payment-dialog {
  .fa-check-circle-o {
    color: var(--green);
  }

  .fa-times-circle-o {
    color: var(--red);
  }

  .fa-question-circle-o {
    color: var(--orange);
  }

  .dialog-body {
    text-align: center;

    i {
      font-size: 30vw;
    }
    p {
      font-size: 150%;
    }
  }
}

</style>
